import React from 'react'

export const CallTollFree = () => {
  return (
    <h2 className="animate__animated animate__fadeInUp">
      <a href="tel:8556455776">Call toll-free 855-645-5776</a>
    </h2>
  )
}
